/* eslint-disable @typescript-eslint/no-unused-vars */
import { styled } from "@mui/material";
import Button from "@mui/material/Button";
import { ReactComponent as FacebookIcon } from "../../../assets/FacebookLogo.svg";
import { useFacebookContext } from "../../../contexts/FacebookProvider";
import { ConnectionStatus } from "../../../contexts/FacebookProvider/index";
import { useGoogleAnalyticsContext } from "../../../contexts/GoogleAnalyticsProvider";
import {
	LOCAL_STORAGE_LOGIN_FROM,
	useWebStoreContext
} from "../../../contexts/WebStoreProvider";
import { LoginType } from "../../../domain/Login/LoginGoogleAnalyticsHelper";
import isFacebookIOSInAppBrowser from "utils/isFacebookIOSInAppBrowser";

const FbLoginButton = styled(Button)`
	font-family: "Poppins", sans-serif;
	display: block;
	width: 100%;
	background: transparent;
	border: 2px solid #245fdc;
	color: #245fdc;
	font-size: 0.7rem;
	text-transform: none;
	position: relative;
	line-height: 2.5;
	&:hover {
		background: #245fdc;
		border: 2px solid #245fdc;
		color: white;
	}
`;

const FacebookLoginButton = ({
	onClick,
	hideLogoutState = false,
	source,
	cbClick,
	prevCb,
	style = { marginTop: "0.75rem" },
	styleNoButton
}: {
	onClick?: () => void;
	cbClick?: () => void;
	prevCb?: () => void;
	hideLogoutState?: boolean;
	source: string;
	style?: React.CSSProperties;
	styleNoButton?: React.CSSProperties;
}) => {
	const { logout } = useWebStoreContext();
	const { connectionStatus } = useFacebookContext();
	const { isConnected, login: fbLogin } = useFacebookContext();
	const { loginGoogleAnalyticsHelper, reportPlaygamiEvent } =
		useGoogleAnalyticsContext();
	const isFacebookIOSInApp = isFacebookIOSInAppBrowser();

	const handleLoginClick = () => {
		prevCb && prevCb();
		if (onClick) {
			onClick();
		} else {
			const feature = source.split("#").pop();
			if (feature) {
				localStorage.setItem(LOCAL_STORAGE_LOGIN_FROM, source);
			}
			fbLogin();
		}
		loginGoogleAnalyticsHelper.reportLoginOptionClick(
			LoginType.Facebook,
			source
		);
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "login_option_click",
			event_type: source,
			action: "login_option_click",
			login_type: LoginType.Facebook,
			source
		});
		// Post-click callbacks
		cbClick && cbClick();
	};

	const shouldShowLoginButton =
		!isConnected ||
		(!hideLogoutState && source === "login_to_continue_dialog#shop");

	return (
		<>
			{shouldShowLoginButton ? (
				isFacebookIOSInApp ? (
					<div
						style={{
							marginTop: "0.5rem",
							fontSize: "0.76rem",
							textAlign: "left",
							...styleNoButton
						}}
					>
						To log in with
						<span
							style={{
								color: "#0452b8",
								fontWeight: 700,
								marginLeft: "0.2rem",
								marginRight: "0.2rem"
							}}
						>
							Facebook
						</span>
						open this page in your device&apos;s browser, not in the Facebook
						app. Tap the three dots (…) and choose &quot;Open in browser&quot;.
					</div>
				) : (
					<FbLoginButton
						variant="contained"
						onClick={handleLoginClick}
						style={style}
						disabled={connectionStatus !== ConnectionStatus.UNKNOWN}
					>
						<FacebookIcon
							style={{
								width: "auto",
								height: "1.5em",
								marginRight: "0.4rem",
								verticalAlign: "middle"
							}}
						/>
						Login with Facebook
					</FbLoginButton>
				)
			) : (
				!hideLogoutState && (
					<FbLoginButton variant="outlined" onClick={logout} style={style}>
						Logout
					</FbLoginButton>
				)
			)}
		</>
	);
};

export default FacebookLoginButton;
